import { CDN_DOMAIN } from '@/configs/env'

/**
 * @param {string} assetUrl
 */
export function normalizeAssetUrl(assetUrl) {
  if (assetUrl.startsWith('/') && !assetUrl.startsWith('//')) {
    return `https://${CDN_DOMAIN}${assetUrl}`
  }

  return assetUrl
}
